import { Injectable, Type } from '@angular/core';


import { Product, ProductTypes } from '@shared/models/products.model';
import { CommandAvailabilityService } from '@shared/services/command-availability.service';

import { BaseRestrictionCommand } from './base-restriction.command';
import { SpendingLimitInlineComponent } from './components/spending-limit-inline/spending-limit-inline.component';
import { RestrictionCommandResult } from './restriction-command.interface';

// TODO: После обновления до Angular 15+ можно будет использовать ngComponentOutletInputs вместо Injector pattern

@Injectable({ providedIn: 'root' })
export class SetSpendingLimitCommand extends BaseRestrictionCommand {
  readonly type = 'setSpendingLimit';
  readonly title = 'Установить лимит на расходные операции';
  readonly icon = 'speedometer';
  readonly isDangerous = false;
  readonly settingsNames = undefined;
  readonly group = 'visibility';
  readonly order = 2;
  readonly inlineComponent: Type<unknown> = SpendingLimitInlineComponent;

  private static readonly ALLOWED_LIMIT_TYPES: ProductTypes[] = [
    ProductTypes.ACCOUNT,
    ProductTypes.INVESTMENT,
    ProductTypes.SAVE_ACCOUNT,
    ProductTypes.METAL_ACCOUNT
  ];

  // Команда доступна только для счетов (accounts)

  constructor(commandAvailabilityService?: CommandAvailabilityService) {
    super(commandAvailabilityService);
  }

  /**
   * Проверка доступности команды
   */
  public override isAvailable(context: { data: Product }): boolean {
    // Команда доступна только для счетов (ACCOUNT, INVESTMENT, SAVE_ACCOUNT, METAL_ACCOUNT)
    const isAllowed = SetSpendingLimitCommand.ALLOWED_LIMIT_TYPES.includes(context.data.productType);

    // Базовая проверка доступности через настройки сервера
    return isAllowed && super.isAvailable(context);
  }

  /**
   * Проверка, установлен ли лимит на счете
   */
  public isLimitSet(product: Product): boolean {
    const hasControlledLimit = typeof product.controlledLimit === 'number' && product.controlledLimit > 0;
    const hasControlledLimitRest = typeof product.controlledLimitRest === 'number' && product.controlledLimitRest >= 0;

    return !!product.asBalance && hasControlledLimit && hasControlledLimitRest;
  }

  /**
   * Проверка, должна ли команда быть отключена (disabled)
   * Команда отключается при установленном запрете на изменение ограничений (forbiddenChange)
   */
  public isDisabled(context: { data: Product }): boolean {
    const product = context.data;

    // Проверяем флаг forbiddenChange (может быть boolean или string "true"/"false")
    if (typeof product.forbiddenChange === 'boolean') {
      return product.forbiddenChange;
    }

    if (typeof product.forbiddenChange === 'string') {
      return product.forbiddenChange.toLowerCase() === 'true';
    }

    return false;
  }

  async execute(context: { data: Product }): Promise<RestrictionCommandResult> {
    // Этот метод больше не вызывается напрямую,
    // вся логика обрабатывается в inline-компоненте
    console.log('SetSpendingLimitCommand.execute called for product:', context.data.id);

    return {
      success: true,
      shouldCloseParent: false
    };
  }
}
